export default __webpack_public_path__ + "static/media/ic-course.6c4ab928.svg";